import React, { Component } from 'react';
import { Link, useLocation } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'
import { List } from 'react-content-loader'
import ReactHtmlParser from 'react-html-parser';
import SideBar from '../sidebar/sidebar'
import TopBar from '../topbar/topbar'
import cluster from '../assets/cluster.jpg'
import center from '../assets/centers.jpg'
import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'
import tmp_img from '../assets/grey.jpg'
import Footer from '../footer/newfooter';

let index = 0
class clusterA extends Component {
    constructor(props) {
        if (props.props) {
            this.setState({
                tab: 2
            })
        }
        super(props);
        this.textInput = React.createRef();
        this.state = {
            mission: '',
            content: '',
            tab: window.location.pathname === "/research/centers" ? 2 : 1
        }

    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    list() {
        Axios(BASE + 'jsonapi/node/page?filter[title]=Research Clusters', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                this.setState({
                    descrption: data.data.data
                })
                console.log('cisdata', data.data.data)
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    componentDidMount() {

        let elem = document.getElementById("centersdata")
        console.log('elements id', elem)
        let params = new URLSearchParams(document.location.search.substring(1));
        let names = params.get('centers')
        console.log('centerscroll gets', names)
        if (names === '2') {
            var headerOffset = 70;
            var elementPosition = elem.getBoundingClientRect().top;
            var offsetPosition = elementPosition - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    }
    componentWillReceiveProps() {
        let elem = document.getElementById("centersdata")
        console.log('elements id', elem)
        let params = new URLSearchParams(document.location.search.substring(1));
        let names = params.get('centers')
        console.log('centerscroll gets', names)
        if (names === '2') {
            var headerOffset = 70;
            var elementPosition = elem.getBoundingClientRect().top;
            var offsetPosition = elementPosition - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    }
    componentWillMount() {
        this.list()
        //Center data
        const id = 'sss'
        //ResrchDiviison
        Axios.get(BASE + 'jsonapi/node/research_clusters?include=field_members_cluster')
            .then((data) => {
                this.setState({
                    cluster: data.data.data,
                    clusterincluded: data.data.included
                })
                console.log('clusters', data.data)
            })
            .catch((err) => {
                console.log('not found')
            })
        Axios.get(BASE + 'jsonapi/taxonomy_term/research_center?include=field_image')
            .then((data) => {
                this.setState({
                    center: data.data.data,
                    centerincluded: data.data.included
                })
                console.log('centers', data.data)
            })
            .catch((err) => {
                console.log('not found')
            })
    }

    setbg() {
        var colors = ['rgb(192, 0, 0)', 'rgb(112, 48, 160)', 'rgb(68, 106, 44)'];
        if (index > colors.length - 1) {
            index = 0;
            return colors[index]
        }
        else {
            index++
            return colors[index - 1]
        }

    }
    render() {
        const cluster = [
            { name: 'Critical Issues in Islamic Studies', link: process.env.PUBLIC_URL + '/cluster/c11.jpg' },
            { name: 'Islamic Finance and Sustainable Economies', link: process.env.PUBLIC_URL + '/cluster/c22.jpg' },
            { name: 'Islamic Civilization: Foundations and Institutions', link: process.env.PUBLIC_URL + '/cluster/c33.jpg' },
            { name: 'Bibliographic Capacity in Islamic Studies', link: process.env.PUBLIC_URL + '/cluster/c44.jpg' },
            { name: 'Islam, Reform and Global Affairs', link: process.env.PUBLIC_URL + '/cluster/c55.jpg' },
            { name: 'Islam and Applied Ethics', link: process.env.PUBLIC_URL + '/cluster/c66.jpg' },
            { name: 'Islamic Art, Architecture and Urbanity', link: process.env.PUBLIC_URL + '/cluster/c77.jpg' }
        ]
        return (
            <div className='formrea clusterpage yourwork sub_work'>
                <div className="title-banner">
                    <h1 className="heading-one bold white-text">{this.state.tab == 2 ? "Research Centers" : "Research Clusters"}</h1>
                </div>
                <div className='container'>

                    <div className="listing">
                        <div className='top-contents'>
                            <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'>&nbsp;<img className='crumb-home' src={home} />&nbsp; </Link>&nbsp;<img className='rightarrow' src={crumbarrow} />&nbsp; Research &nbsp; <img className='rightarrow' src={crumbarrow} />&nbsp; <Link to={this.state.tab === 2 ? "/research/centers" : '/research/cluster'} className='gray-text'>{this.state.tab == 1 ? "Research Clusters" : "Research Centers"}</Link></div>
                            {/* <TopBar data={'data1'} /> */}
                        </div>
                        {this.state.descrption ? this.state.descrption[0].attributes.body ?
                            <div className="body-two gray-text text-justify">
                                {ReactHtmlParser(this.state.descrption[0].attributes.body.value)}
                            </div>
                            : '' : ''}

                        {this.state.tab == 1 ? this.state.cluster ?
                            <div className="col-sm-6 mission clusterlist">
                                {this.state.cluster.map((inst, ind) => {
                                    let aa = inst.attributes.title.toString()
                                    let links = aa.replace(/ /g, '-')
                                    return (
                                        <Link to={{ pathname: '/cluster_details1/' + `${links}` }} style={{ marginRight: (ind + 1) % 4 === 0 ? "0%" : "" }}>
                                            <img src="/cluster/c11.jpg" />
                                            <p className='subtitle-one text-center bold'>{inst.attributes.title}</p>
                                            {/* <p className='a-body'>{ReactHtmlParser(inst.attributes.body.value)}</p> */}
                                        </Link>
                                    )
                                })}
                            </div> : <List /> : ""
                        }
                        {this.state.tab == 2 ? this.state.center ? this.state.center.length !== 0 ?
                            <div className='col-sm-6 mission centerlist'>
                                {this.state.center.map((inst, index) => {
                                    return (
                                        <a target="_blank" href={inst.attributes.field_link.uri}>
                                            <img src={inst.relationships.field_image.data ? BASE + this.state.centerincluded.filter(o => o.id === inst.relationships.field_image.data.id)[0].attributes.uri.url
                                                : tmp_img} />
                                            <p className='subtitle-one text-center bold'>{inst.attributes.name}</p>
                                            {/* <p className='a-body'>{inst.attributes.field_description ? ReactHtmlParser(inst.attributes.field_description) : ""}</p> */}
                                        </a>
                                    )
                                })}

                            </div> : '' : <List /> : ""
                        }
                    </div>
                </div>
                <Footer />
            </div >
        )


    }

}


export default clusterA;
